module.exports = __webpack_public_path__ + "static/media/wwc-react-workshop-leader.b77fd15d.png";